// pages/NouveauMotDePassePage.jsx
// Mot de passe oublié, écran 2 : ouvert depuis le lien reçu par e-mail
// (/nouveau-mot-de-passe#jeton=...). Le jeton est dans le fragment (jamais envoyé au serveur par le
// navigateur) : on le lit une fois, on l'efface de l'adresse, puis on l'envoie tel quel (opaque).

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import { envoyerAuth, langueInterface, messageErreurOubli, LONGUEUR_MIN_MOT_DE_PASSE } from '../utils/authOubli';
import { useJetonFragment } from '../utils/jetonFragment';
import './AuthPages.css';
import ChampMotDePasse from '../components/ChampMotDePasse';

export default function NouveauMotDePassePage() {
  const { t, i18n } = useTranslation();
  const [motDePasse, setMotDePasse] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreur, setErreur] = useState('');
  const [termine, setTermine] = useState(false);
  const [enCours, setEnCours] = useState(false);

  // À chaque nouveau jeton (ouverture ou lien cliqué dans l'onglet déjà ouvert) : on repart de zéro
  const jeton = useJetonFragment(() => {
    setMotDePasse('');
    setConfirmation('');
    setErreur('');
    setTermine(false);
    setEnCours(false);
  });

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur('');
    if (Array.from(motDePasse).length < LONGUEUR_MIN_MOT_DE_PASSE) return setErreur(t('auth.mdpTropCourt', { min: LONGUEUR_MIN_MOT_DE_PASSE }));
    if (motDePasse !== confirmation) return setErreur(t('auth.mdpNeCorrespondentPas'));
    setEnCours(true);
    const rep = await envoyerAuth('/api/auth/nouveau-mot-de-passe', { jeton, motDePasse, langue: langueInterface(i18n) });
    setEnCours(false);
    if (rep.ok) setTermine(true); else setErreur(messageErreurOubli(t, rep.code));
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <BookOpen size={40} color="#4F46E5" />
          <h1>VocaVerb</h1>
          <p>{t('auth.nouveauMdpSubtitle')}</p>
        </div>

        {erreur && <div className="auth-error">{erreur}</div>}

        {termine ? (
          <div className="auth-success">{t('auth.mdpChange')}</div>
        ) : jeton ? (
          <form onSubmit={soumettre} className="auth-form">
            <div className="form-group">
              <label htmlFor="nouveauMdp">{t('auth.nouveauMdp')}</label>
              <ChampMotDePasse id="nouveauMdp" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} required autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label htmlFor="confirmationMdp">{t('auth.confirmerMdp')}</label>
              <ChampMotDePasse id="confirmationMdp" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} required autoComplete="new-password" />
            </div>
            <button type="submit" className="auth-submit" disabled={enCours}>{t('auth.changerMdp')}</button>
          </form>
        ) : (
          <>
            <div className="auth-error">{t('auth.lienInvalide')}</div>
            <div className="auth-footer"><p><Link to="/mot-de-passe-oublie">{t('auth.demanderNouveauLien')}</Link></p></div>
          </>
        )}

        <div className="auth-footer">
          <p><Link to="/login">{t('auth.retourConnexion')}</Link></p>
        </div>
      </div>
    </div>
  );
}
